export const READING_PATH_PREFIX = "/api/reading/";

export const readingPath = (readingId: string): string =>
  `${READING_PATH_PREFIX}${encodeURIComponent(readingId)}`;
